var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamBackdropCam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8C10.374 8 9 9.374 9 11C9 12.626 10.374 14 12 14C13.626 14 15 12.626 15 11C15 9.374 13.626 8 12 8ZM12 12.5C11.2013 12.5 10.5 11.7987 10.5 11C10.5 10.2013 11.2013 9.5 12 9.5C12.7987 9.5 13.5 10.2013 13.5 11C13.5 11.7987 12.7987 12.5 12 12.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6 7H15.7898L13.8949 5.19533C13.83 5.13331 13.7529 5.08411 13.6679 5.05059C13.583 5.01707 13.4919 4.99987 13.4 5H10.6C10.5081 4.99987 10.417 5.01707 10.3321 5.05059C10.2471 5.08411 10.17 5.13331 10.1051 5.19533L8.2102 7H6.4C5.6279 7 5 7.598 5 8.33333V15.6667C5 16.402 5.6279 17 6.4 17H17.6C18.3721 17 19 16.402 19 15.6667V8.33333C19 7.598 18.3721 7 17.6 7ZM6.4 15.6667V8.33333H8.5C8.6862 8.33333 8.864 8.26333 8.9949 8.138L10.8898 6.33333H13.1102L15.0051 8.138C15.07 8.20003 15.1471 8.24922 15.2321 8.28274C15.317 8.31627 15.4081 8.33346 15.5 8.33333H17.6L17.6014 15.6667H6.4Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBackdropCam);
export default __webpack_public_path__ + "static/media/teamBackdropCam.2bc84fd4e86e8781b2726bebd3ea9439.svg";
export { ForwardRef as ReactComponent };